import { v4 as uuidv4 } from 'uuid';

const SESSION_STORAGE_KEY = 'atrivial_error_session_id';
let inMemorySessionId: string | undefined;

function getInMemorySessionId(): string {
  inMemorySessionId ??= uuidv4();
  return inMemorySessionId;
}

export function getOrCreateSessionId(): string {
  if (typeof window === 'undefined') {
    return '00000000-0000-4000-8000-000000000000';
  }

  if (inMemorySessionId) return inMemorySessionId;

  let storage: Storage;
  try {
    storage = window.sessionStorage;
  } catch {
    return getInMemorySessionId();
  }

  let existing: string | null;
  try {
    existing = storage.getItem(SESSION_STORAGE_KEY);
  } catch {
    return getInMemorySessionId();
  }

  if (existing) return existing;

  const sessionId = uuidv4();
  try {
    storage.setItem(SESSION_STORAGE_KEY, sessionId);
  } catch {
    inMemorySessionId = sessionId;
  }
  return sessionId;
}

export function getBuildId(): string | undefined {
  const buildId = import.meta.env.VITE_APP_BUILD_ID;
  if (typeof buildId === 'string' && buildId.length > 0 && buildId !== 'unknown') return buildId;
  if (typeof document === 'undefined') return undefined;

  const documentBuildId = document
    .querySelector<HTMLMetaElement>('meta[name="atrivial-build-id"]')
    ?.content.trim();
  return documentBuildId && documentBuildId !== 'unknown' ? documentBuildId : undefined;
}

export function getEnvironment(): string {
  if (import.meta.env.VITEST) return 'test';
  return import.meta.env.MODE || 'development';
}

export function getRoutePathname(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  return window.location.pathname;
}

export function getDeviceSnapshot(): Record<string, unknown> {
  if (typeof window === 'undefined') {
    return {};
  }

  return {
    userAgent: navigator.userAgent,
    viewport: {
      width: window.innerWidth,
      height: window.innerHeight,
    },
    online: navigator.onLine,
    theme: document.documentElement.getAttribute('data-theme') ?? undefined,
  };
}

export function isTelemetryEnabled(): boolean {
  if (import.meta.env.VITEST) return false;
  return import.meta.env.VITE_ERROR_TELEMETRY_ENABLED === 'true';
}
